
import {PropertyBase} from "./PropertyBase";
import {RNColor} from "shared/controls/SingleInputs/RNColor/RNColor";
import {RNTextInput} from "shared/controls/SingleInputs/RNTextInput";
import * as React from "react";
import {CSSProperties} from "react";
declare let rednaoPDFInvoiceParams:any;

export class ColorProperty extends PropertyBase{
    public label:string='Color';


    public SubRenderer(): React.ReactNode {
        return <RNColor Label={this.label} Value={this.GetOptionValue(this.OptionsPropertyName)} onChange={e=>this.SetOptionValue(e,this.OptionsPropertyName)} disabled={this.disabled}/>
    }


    public SetLabel(value:string)
    {
        this.label=value;
        return this;
    }



}

